import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { UserPermissions } from "../../services/user-permissions";
import { getString } from "../ui-string-labels/ui-strings-utils";
import { BUG_REPORT_URL } from "../../interfaces/constants";
import Paths from "common/paths/paths";
import BugIcon from "./BugIcon";

const getStringPath: string = "common.topNav";

const CustomHeader = () => {
  return (
      <TopNavigation
      data-testid="top-navigation-bar"
      identity={{
        href: Paths.Admin.url,
        title: getString(`${getStringPath}.title`),
      }}
      utilities={[
        {
          type: "button",
          iconSvg: BugIcon,
          text: getString(`${getStringPath}.bugReport.text`),
          title: getString(`${getStringPath}.bugReport.title`),
          href: BUG_REPORT_URL,
          external: true,
          externalIconAriaLabel: getString(`${getStringPath}.bugReport.externalIconAriaLabel`),
          ariaLabel: getString(`${getStringPath}.bugReport.text`),
        },
        {
          type: "button",
          text: UserPermissions.instance.username,
          iconName: "user-profile"
        }
      ]}
      i18nStrings={{
        overflowMenuTriggerText: "More",
        overflowMenuTitleText: "All",
      }}
    />
  );
}

export default CustomHeader;
